import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { IAdminUsersService } from '../../interfaces/services/admin-users-service.interface';
import {
  AdminUser,
  CreateAdminUserRequest,
  UpdateAdminUserRequest,
} from '../../interfaces/state/entities/admin-user.interface';

@Injectable({ providedIn: 'root' })
export class AdminUsersMockService implements IAdminUsersService {
  private users: AdminUser[] = [
    {
      id: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
      name: 'Alex Developer',
      email: 'alex.developer@example.com',
      roles: ['User'],
    },
    {
      id: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
      name: 'Sam Support',
      email: 'sam.support@example.com',
      roles: ['Support'],
    },
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
      name: 'Pat Admin',
      email: 'pat.admin@example.com',
      roles: ['Admin'],
    },
    {
      id: 'dddddddd-dddd-dddd-dddd-dddddddddddd',
      name: 'Morgan Multi',
      email: 'morgan.multi@example.com',
      roles: ['User', 'Support'],
    },
    {
      id: 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
      name: 'Riley Universal',
      email: 'riley.universal@example.com',
      roles: ['User', 'Support', 'Admin'],
    },
  ];

  getUsers(): Observable<AdminUser[]> {
    return of([...this.users]).pipe(delay(80));
  }

  createUser(request: CreateAdminUserRequest): Observable<void> {
    const id = request.userId.trim();
    return of(void 0).pipe(
      delay(60),
      tap(() => {
        this.users = [
          ...this.users,
          {
            id,
            name: request.name.trim(),
            email: request.email.trim(),
            roles: [...request.roles],
          },
        ];
      })
    );
  }

  updateUser(request: UpdateAdminUserRequest): Observable<void> {
    const id = request.userId.trim();
    return of(void 0).pipe(
      delay(60),
      tap(() => {
        this.users = this.users.map((user) =>
          user.id === id ? { ...user, roles: [...request.roles] } : user
        );
      })
    );
  }

  deleteUser(id: string): Observable<void> {
    return of(void 0).pipe(
      delay(60),
      tap(() => {
        this.users = this.users.filter((u) => u.id !== id);
      })
    );
  }
}
